/**
 * CYBER_ORCH_ARCHETYPE
 *
 * The "Ground Truth" statistical profile for Cyber-Orchestral / Hybrid Sci-Fi.
 * Traits:
 * - Mechanical/Motor Rhythm (High Rhythmic Lock)
 * - Hybrid Texture (Orchestral Lows + Synth Highs)
 * - Cold/Precise Dynamics
 */

import { SLOW_ARCHETYPE } from './BaseArchetype.js';

export const CYBER_ORCH_ARCHETYPE = {
    ...SLOW_ARCHETYPE,

    // Harmonic Rhythm: Static to Fast.
    // Often stays on a pedal or riff for long periods, then shifts rapidly.
    harmonicRhythm: {
        ...SLOW_ARCHETYPE.harmonicRhythm,
        target: 4.0, // Slow functional change (Drone/Riff based)
        tolerance: 2.0
    },

    // Voice Distribution: "Hollow" or "V-Shape".
    // Massive Lows (Sub/Brass) and piercing Highs (Synth/Violins).
    // Empty Mid-range to leave room for sound design.
    voiceDistribution: {
        ...SLOW_ARCHETYPE.voiceDistribution,
        low: 0.40,
        mid: 0.20,
        high: 0.40,
        tolerance: 0.20,
        tuttiThreshold: 0.85
    },

    // Dynamic Range: Controlled but Powerful.
    // Not as expressive as Romantic. More "On/Off" or terraced swells.
    dynamicRange: {
        ...SLOW_ARCHETYPE.dynamicRange,
        minVariance: 0.15,
        targetVariance: 0.25
    },

    // Interval Entropy: Mechanical.
    // Repetitive figures (Ostinatos).
    intervalEntropy: {
        ...SLOW_ARCHETYPE.intervalEntropy,
        stepRatio: 0.50, // Balance between step and leap (Arps)
        tolerance: 0.20
    },

    // Rhythmic Lock: Critical.
    // Machine-like precision between layers.
    rhythmicLock: {
        ...SLOW_ARCHETYPE.rhythmicLock,
        target: 0.95,
        weight: 0.4 // Highest priority
    }
};
